import React, { useMemo } from 'react';

export default function MultiSelectField({
	id,
	label,
	options,
	selectedValues,
	onChange,
	placeholderAll = 'Tous',
}) {
	const selectedSet = useMemo(() => new Set(selectedValues), [selectedValues]);
	const allSelected = options.length > 0 && selectedValues.length === options.length;
	const summary = selectedValues.length === 0
		? placeholderAll
		: allSelected
			? `${placeholderAll} (${selectedValues.length})`
			: `${selectedValues.length} sélectionné${selectedValues.length > 1 ? 's' : ''}`;

	return (
		<div className="new-results-field">
			<label htmlFor={id}>{label}</label>
			<details className="new-results-multi-filter">
				<summary id={id}>{summary}</summary>
				<div className="new-results-multi-filter-menu">
					<div className="new-results-multi-filter-actions">
						<button type="button" onClick={() => onChange(options)}>
							Tout sélectionner
						</button>
						<button type="button" onClick={() => onChange([])}>
							Tout retirer
						</button>
					</div>
					<div className="new-results-multi-filter-list">
						{options.length === 0 && (
							<p className="new-results-hint">Aucune valeur.</p>
						)}
						{options.map((value) => (
							<label key={value} className="new-results-multi-filter-option">
								<input
									type="checkbox"
									checked={selectedSet.has(value)}
									onChange={(e) => {
										if (e.target.checked) {
											onChange([...selectedValues, value]);
										} else {
											onChange(selectedValues.filter((item) => item !== value));
										}
									}}
								/>
								<span>{value}</span>
							</label>
						))}
					</div>
				</div>
			</details>
		</div>
	);
}
